import React from 'react';
import { COLORS } from '../../theme';

export default function Modal({ titulo, onFechar, children, largura = 700, rodape }) {
  return (
    <div
      onClick={onFechar}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.32)',
        backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#FFFFFF', borderRadius: 20, width: '92%', maxWidth: largura,
          maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(15,23,42,0.15)', border: `1px solid ${COLORS.border}`
        }}
      >
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '20px 28px 16px', borderBottom: `1px solid ${COLORS.border}`
        }}>
          <strong style={{ fontSize: 16, fontWeight: 700, color: COLORS.text }}>{titulo}</strong>
          <button
            onClick={onFechar}
            style={{
              background: COLORS.gray, border: `1px solid ${COLORS.border}`, borderRadius: 8,
              width: 30, height: 30, fontSize: 18, color: COLORS.textMid, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
          >×</button>
        </div>
        <div style={{ padding: 28, overflowY: 'auto', flex: 1 }}>{children}</div>
        {rodape && (
          <div style={{ padding: '16px 28px', borderTop: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            {rodape}
          </div>
        )}
      </div>
    </div>
  );
}
